import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "../../Style.css";
import { toast, ToastContainer } from "react-toastify";
import { useCombinedContext } from "../../context/CombinedContext";
import axiosInstance from "../../services/auth";

const Login = () => {
  const url = process.env.REACT_APP_BACKEND_URL;
  // console.log("env", process.env.REACT_APP_BACKEND_URL);
  const { company, setCompany, setUser } = useCombinedContext();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${url}/auth/login`, {
        email,
        password,
      });

      // console.log("Response received from server:", response.data);

      const { token, user } = response.data;

      if (token && user) {
        const { _id, name, email: userEmail, image, company, role, route } = user;
        const userData = {
          _id,
          name,
          role,
          email: userEmail,
          profilePicture: image,
          company,
          route,
        };
        //  setUser(userData)
        //  console.log("User data to save:", userData);

        if (rememberMe) {
          localStorage.setItem("authToken", token);
          localStorage.setItem("authData", JSON.stringify(userData));
          // console.log("Saved to localStorage.");
        } else {
          sessionStorage.setItem("authToken", token);
          sessionStorage.setItem("authData", JSON.stringify(userData));
          // console.log("Saved to sessionStorage.");
        }

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        // console.log("Axios header set to:", axios.defaults.headers.common["Authorization"]);
        // const companies = await axios.get(`${url}/auth/profile`)
        // console.log("companies data",companies.data.data)
        // setCompany(companies.data.data);
        if (userData.role === "superadmin") {
          navigate("/home");
        } else {
          // If the first route is "profile" (or "/profile"), then navigate to the second route if available.
          let destinationRoute = "";
          if (
            (userData.route[0] === "profile" ||
              userData.route[0] === "/profile") &&
            userData.route[1]
          ) {
            destinationRoute = userData.route[1];
          } else {
            destinationRoute = userData.route[0];
          }
          // Ensure the route starts with a "/"
          if (!destinationRoute.startsWith("/")) {
            destinationRoute = "/" + destinationRoute;
          }
          navigate(destinationRoute);
        }
        toast.success("Login Successfully");
        // console.log("Redirected to Dashboard.");
      } else {
        toast.error("Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);
      toast.error("Invalid Email or Password. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // Check for token in localStorage or sessionStorage on component mount
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      navigate("/home");
    }
  }, [navigate]);
  return (
    <>
      <ToastContainer />
      <div className="d-flex justify-content-center align-items-center vh-100 auth-bg p-2">
        <div
          className="card p-4 shadow-lg"
          style={{
            maxWidth: "400px",
            width: "100%",
            borderRadius: "15px",
            backgroundColor: "#fff",
            color: "#333",
          }}
        >
          <div className="text-center mb-4">
            <h3 className="mt-2" style={{ fontWeight: "600" }}>
              Login
            </h3>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                <i
                  className="bi bi-envelope-fill me-2"
                  style={{ color: "#2a5298" }}
                ></i>
                Email
              </label>
              <input
                type="email"
                className="form-control shadow-sm"
                id="email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ borderRadius: "10px" }}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                <i
                  className="bi bi-lock-fill me-2"
                  style={{ color: "#2a5298" }}
                ></i>
                Password
              </label>
              <input
                type="password"
                className="form-control shadow-sm"
                id="password"
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ borderRadius: "10px" }}
              />
            </div>

            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{
                  backgroundColor: "#2a5298",
                  border: "none",
                }}
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember Me
              </label>
            </div>

            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="btn btn-primary btn-lg shadow-sm"
                disabled={loading}
                aria-disabled={loading}
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#2a5298",
                  border: "none",
                  width: "100%",
                }}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
            <div className="d-flex justify-content-start align-items-center mt-3">
              <Link
                to="/forgot"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textDecoration: "none",
                  color: "#2a5298",
                }}
              >
                Forgot?
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
